import { render, staticRenderFns } from "./Thank.vue?vue&type=template&id=6a6d642f&scoped=true&"
import script from "./Thank.vue?vue&type=script&lang=js&"
export * from "./Thank.vue?vue&type=script&lang=js&"
import style0 from "./Thank.vue?vue&type=style&index=0&id=6a6d642f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6d642f",
  null
  
)

export default component.exports